import HeroBlog from "./components/HeroBlog";
import Loader from "../../components/Loader";
import ErrorWrapper from "../../components/ui/wrappers/ErrorWrapper";
import CardArticle from "./components/CardArticle";
import H2Base from "../../components/ui/titles/H2Base";
import { useArticlePreviews } from "../../hooks/useArticlePreviews";
import PageWrapper from "../../components/ui/wrappers/PageWrapper";
import Seo from "../../components/Seo";

const HomeBlog = () => {
    const { isLoading, articles, error, isError } = useArticlePreviews();

    if (isLoading) {
        return <div className="mb-12">
            <Loader />
        </div>;
    }

    if (isError) {
        return <div className="mb-12">
            <ErrorWrapper error={error?.message || ""} />
        </div>;
    }

    if (articles.length === 0) {
        return <div className="mb-12">
            <ErrorWrapper error={"Aucun article trouve"} />
        </div>;
    }

    return <PageWrapper>
        <Seo
            title="Blog"
            description="Blog PretUp : actualites, conseils et analyses sur l'investissement, le crowdlending, la diversification et le financement des entreprises."
        />
        <HeroBlog article={articles[0]} />
        <H2Base text={"Derniers articles"} />
        <div className={"max-w-screen-xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-10"}>
            {articles.map((article, index) => <CardArticle
                article={article}
                key={`cardArticle-${index}-${article.idArticle}`}
            />)
            }
        </div>
    </PageWrapper>;
};

export default HomeBlog;
